import React from 'react'
import { IonIcon } from 'controls'
import { iconInfoStyle } from './style.js'

const IconInfo = ({ icon, title, content }) => (
  <div className="icon-info-wrapper">
    <div className="cicle-wrapper-icon">
      <IonIcon icon={icon} size="large" />
    </div>
    <h4>{title}</h4>
    <p>{content}</p>
    <style jsx>{iconInfoStyle}</style>
  </div>
)

export default IconInfo
